var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3562 0.969202C13.7283 0.656164 14.2717 0.656164 14.6438 0.969202L27.0572 11.4124C27.7711 12.013 27.3464 13.1776 26.4134 13.1776H1.58657C0.653598 13.1776 0.228876 12.013 0.942808 11.4124L13.3562 0.969202Z","fill":"#A4202F"}));
}

Triangle.defaultProps = {"width":"28","height":"14","viewBox":"0 0 28 14","fill":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
